import { render, staticRenderFns } from "./HorizontalNavMenuItem.vue?vue&type=template&id=a827ca9e&"
import script from "./HorizontalNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNavMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports